<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="pagevi"></a>Abbreviations</h2>
<table width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td valign="top">AA:</td>
<td valign="top">Anti-aircraft</td>
</tr>
<tr>
<td valign="top">ACP:</td>
<td valign="top">Armoured Command Post</td>
</tr>
<tr>
<td valign="top">AFV:</td>
<td valign="top">Armoured Fighting Vehicle</td>
</tr>
<tr>
<td valign="top">AP:</td>
<td valign="top">Armour-piercing</td>
</tr>
<tr>
<td valign="top">APC:</td>
<td valign="top">Armoured Personnel Carrier</td>
</tr>
<tr>
<td valign="top">CRA:</td>
<td valign="top">Commander, Royal Artillery</td>
</tr>
<tr>
<td valign="top">FOO:</td>
<td valign="top">Forward Observation Officer</td>
</tr>
<tr>
<td valign="top">FTO:</td>
<td valign="top">Forward Tank Officer</td>
</tr>
<tr>
<td valign="top">FUP:</td>
<td valign="top">Forming-up Point</td>
</tr>
<tr>
<td valign="top">HE:</td>
<td valign="top">High Explosive</td>
</tr>
<tr>
<td valign="top">IO:</td>
<td valign="top">Intelligence Officer</td>
</tr>
<tr>
<td valign="top">LAD:</td>
<td valign="top">Light Aid Detachment</td>
</tr>
<tr>
<td valign="top">LCA:</td>
<td valign="top">Landing Craft Assault</td>
</tr>
<tr>
<td valign="top">LCT:</td>
<td valign="top">Landing Craft Tank</td>
</tr>
<tr>
<td valign="top">LMG:</td>
<td valign="top">Light Machine Gun</td>
</tr>
<tr>
<td valign="top">MDS:</td>
<td valign="top">Main Dressing Station</td>
</tr>
<tr>
<td valign="top">MG:</td>
<td valign="top">Machine Gun</td>
</tr>
<tr>
<td valign="top">MMG:</td>
<td valign="top">Medium Machine Gun</td>
</tr>
<tr>
<td valign="top">OP:</td>
<td valign="top">Observation Post</td>
</tr>
<tr>
<td valign="top">SDM:</td>
<td valign="top">Squadron Dafadar Major (Indian Cavalry Rank)</td>
</tr>
<tr>
<td valign="top">SHQ:</td>
<td valign="top">Squadron Headquarters</td>
</tr>
<tr>
<td valign="top">SP:</td>
<td valign="top">Self-propelled</td>
</tr>
<tr>
<td valign="top">SSM:</td>
<td valign="top">Squadron Sergeant Major</td>
</tr>
<tr class="spaceUper">
<td valign="top">KOSB:</td>
<td valign="top">King’s Own Scottish Borderers</td>
</tr>
<tr>
<td valign="top">KOYLI:</td>
<td valign="top">King’s Own Yorkshire Light Infantry</td>
</tr>
<tr>
<td valign="top">PAVO:</td>
<td valign="top">Prince Albert Victor’s Own Cavalry</td>
</tr>
<tr>
<td valign="top">RA:</td>
<td valign="top">Royal Artillery</td>
</tr>
<tr>
<td valign="top">RAC:</td>
<td valign="top">Royal Armoured Corps</td>
</tr>
<tr>
<td valign="top">RE:</td>
<td valign="top">Royal Engineers</td>
</tr>
<tr>
<td valign="top">RTR:</td>
<td valign="top">Royal Tank Regiment</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_abbreviations.vue?416396c2